/**
 * 약관 시트에서 고른 마케팅 수신 동의를 가입 완료 시점까지 들고 간다.
 *
 * 왜 따로 보관하나
 * ---------------
 * 동의는 첫 화면(휴대폰 번호 입력)의 약관 시트에서 받는데, 실제 계정 생성은
 * 인증번호 확인 → 아이디/닉네임 입력을 거친 뒤에 일어난다. 화면이 두 번
 * 바뀌는 동안 값을 들고 있을 곳이 필요하다.
 *
 * 원래는 이 값이 그냥 버려지고 있었다. 시트는 제대로 넘겼는데 받는 쪽
 * handleAgree가 인자를 받지 않았다.
 *
 * sessionStorage를 쓰는 이유
 * ------------------------
 * 가입을 중간에 그만두면 남아 있으면 안 되는 값이다. 탭을 닫으면 사라지고,
 * 가입이 끝나면 바로 지운다.
 */
const KEY = 'signup_marketing_consent'

export function rememberMarketingConsent(agreed: boolean): void {
  try {
    sessionStorage.setItem(KEY, agreed ? '1' : '0')
  } catch {
    // 저장소를 못 쓰면 동의하지 않은 것으로 처리된다.
    // 광고성 알림은 안 가는 쪽이 안전한 실패다.
  }
}

/** 읽으면서 지운다. 다음 가입에 남지 않게 한다 */
export function takeMarketingConsent(): boolean {
  try {
    const v = sessionStorage.getItem(KEY)
    sessionStorage.removeItem(KEY)
    return v === '1'
  } catch {
    return false
  }
}
